module.exports = __webpack_public_path__ + "img/logo3.2587caba.png";